(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
function initHeaderV3(root=document){
  const navigation=root.querySelector('[data-desktop-navigation]');
  navigation?.querySelectorAll('[data-nav-disclosure]').forEach(group=>{
    if(group.dataset.navReady)return;group.dataset.navReady='true';
    const trigger=group.querySelector(':scope > .nav-parent [data-nav-toggle]');
    let closeTimer;
    const setOpen=value=>{group.classList.toggle('is-open',value);trigger?.setAttribute('aria-expanded',String(value));};
    const closeOthers=()=>navigation.querySelectorAll('[data-nav-disclosure].is-open').forEach(other=>{if(other!==group){other.classList.remove('is-open');other.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded','false');}});
    const open=()=>{window.clearTimeout(closeTimer);closeOthers();setOpen(true);};
    const close=()=>{window.clearTimeout(closeTimer);closeTimer=window.setTimeout(()=>setOpen(false),220);};
    group.addEventListener('pointerenter',open);
    group.addEventListener('pointerleave',close);
    group.addEventListener('focusin',open);
    group.addEventListener('focusout',event=>{if(!group.contains(event.relatedTarget))setOpen(false);});
    trigger?.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();const next=!group.classList.contains('is-open');closeOthers();setOpen(next);});
    trigger?.addEventListener('keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();open();requestAnimationFrame(()=>group.querySelector(':scope > .mega-menu-panel a, :scope > .nav-dropdown a')?.focus());}});
  });
  navigation?.addEventListener('keydown',event=>{if(event.key==='Escape'){navigation.querySelectorAll('[data-nav-disclosure].is-open').forEach(group=>{group.classList.remove('is-open');group.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded','false');});}});
  root.querySelectorAll('[data-mobile-menu]').forEach(drawer=>{
    if(drawer.dataset.v3Ready)return;drawer.dataset.v3Ready='true';
    const panels=[...drawer.querySelectorAll('[data-mobile-panel]')];
    const show=(id,moveFocus=true)=>{panels.forEach(panel=>panel.hidden=panel.dataset.mobilePanel!==id);const active=panels.find(panel=>!panel.hidden);active?.scrollTo(0,0);if(moveFocus)active?.querySelector('button,a')?.focus();};
    drawer.addEventListener('click',event=>{const next=event.target.closest('[data-mobile-next]');if(next){event.preventDefault();show(next.dataset.mobileNext);}const back=event.target.closest('[data-mobile-back]');if(back){event.preventDefault();show(back.dataset.mobileBack);}});
    drawer.addEventListener('close',()=>show('root',false));
  });
}
document.addEventListener('DOMContentLoaded',()=>initHeaderV3());
document.addEventListener('shopify:section:load',event=>initHeaderV3(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function setup(section) {
      if (section.dataset.reviewReady === 'true') return;
      section.dataset.reviewReady = 'true';
      const dialog = section.querySelector('[data-review-dialog]');
      const openButton = section.querySelector('[data-review-dialog-open]');
      const closeButton = section.querySelector('[data-review-dialog-close]');
      openButton?.addEventListener('click', () => {
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
      closeButton?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      });

      const list = section.querySelector('[data-review-list]');
      if (!list) return;
      const sort = section.querySelector('[data-review-sort]');
      const more = section.querySelector('[data-review-more]');
      const initial = Math.max(1, Number(section.dataset.initialCount) || 3);
      let expanded = false;
      const arrange = () => {
        const cards = [...list.querySelectorAll('[data-review-card]')];
        cards.sort((a, b) => sort?.value === 'highest'
          ? Number(b.dataset.rating) - Number(a.dataset.rating) || String(b.dataset.date).localeCompare(String(a.dataset.date))
          : String(b.dataset.date).localeCompare(String(a.dataset.date)));
        cards.forEach((card, index) => {
          list.append(card);
          card.hidden = !expanded && index >= initial;
        });
        if (more) more.hidden = expanded || cards.length <= initial;
      };
      sort?.addEventListener('change', arrange);
      more?.addEventListener('click', () => {
        expanded = true;
        arrange();
      });
      arrange();
    }

    function initialize(scope = document) {
      scope.querySelectorAll('[data-pdp-customer-reviews]').forEach(setup);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-color"]) return;
  try {
    
if (!window.colorFamilyNavigationBound) {
  window.colorFamilyNavigationBound = true;

  const setActiveColorFamily = (navigation, activeCard) => {
    navigation.querySelectorAll('.palette-card.is-active').forEach((card) => {
      card.classList.remove('is-active');
    });
    if (activeCard) activeCard.classList.add('is-active');
  };

  document.addEventListener('pointerover', (event) => {
    const trigger = event.target.closest('[data-color-navigation] .palette-card__link');
    if (!trigger) return;
    setActiveColorFamily(trigger.closest('[data-color-navigation]'), trigger.closest('.palette-card'));
  });

  document.addEventListener('focusin', (event) => {
    const trigger = event.target.closest('[data-color-navigation] .palette-card__link');
    if (!trigger) return;
    setActiveColorFamily(trigger.closest('[data-color-navigation]'), trigger.closest('.palette-card'));
  });

  document.addEventListener('pointerleave', (event) => {
    const navigation = event.target instanceof Element ? event.target.closest('[data-color-navigation]') : null;
    if (!navigation || (event.relatedTarget && navigation.contains(event.relatedTarget))) return;
    setActiveColorFamily(navigation, null);
  }, true);

  document.addEventListener('focusout', (event) => {
    const navigation = event.target instanceof Element ? event.target.closest('[data-color-navigation]') : null;
    if (!navigation || (event.relatedTarget && navigation.contains(event.relatedTarget))) return;
    setActiveColorFamily(navigation, null);
  }, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-size-guide-section]').forEach((section) => {
    if (section.dataset.sizeGuideReady === 'true') return;
    section.dataset.sizeGuideReady = 'true';
    const buttons = section.querySelectorAll('[data-size-unit]');
    const cells = section.querySelectorAll('[data-in][data-cm]');
    const caption = section.querySelector('[data-unit-caption]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const unit = button.dataset.sizeUnit;
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        cells.forEach((cell) => { cell.textContent = cell.dataset[unit]; });
        if (caption) caption.textContent = unit === 'cm' ? section.dataset.captionCm : section.dataset.captionIn;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
